import { render, staticRenderFns } from "./SectionGallery.component.vue?vue&type=template&id=69678239&"
import script from "./SectionGallery.component.vue?vue&type=script&lang=js&"
export * from "./SectionGallery.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports